// @ts-nocheck
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Logout, LogoutDevice } from 'store/legacyActionsBridge';

function LogoutPage() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    function handleClick() {
        if (document.getElementById('__logout_modal__')) return;

        const overlay = document.createElement('div');
        overlay.id = '__logout_modal__';
        overlay.style.cssText = [
            'position:fixed', 'inset:0', 'z-index:2147483647',
            'background:rgba(0,0,0,0.5)',
            'display:flex', 'align-items:center', 'justify-content:center',
            'font-family:inherit',
        ].join(';');

        const box = document.createElement('div');
        box.style.cssText = [
            'background:#fff', 'border-radius:12px',
            'padding:28px 24px 20px',
            'width:340px', 'max-width:90vw',
            'box-shadow:0 8px 32px rgba(0,0,0,0.2)',
        ].join(';');

        const title = document.createElement('p');
        title.textContent = 'Çıkış Yap';
        title.style.cssText = 'font-weight:700;font-size:17px;margin:0 0 6px;color:#1a1a2e';

        const subtitle = document.createElement('p');
        subtitle.textContent = 'Nasıl çıkış yapmak istiyorsunuz?';
        subtitle.style.cssText = 'font-size:14px;color:#666;margin:0 0 20px';

        function close() {
            overlay.remove();
        }

        function makeBtn(text, bg, color, border, textAlign) {
            const btn = document.createElement('button');
            btn.textContent = text;
            btn.style.cssText = [
                'display:block', 'width:100%', 'padding:11px 16px',
                'border-radius:8px', `border:${border}`,
                'cursor:pointer', 'font-size:14px', 'font-weight:600',
                'margin-bottom:8px', `text-align:${textAlign || 'left'}`,
                `background:${bg}`, `color:${color}`,
            ].join(';');
            return btn;
        }

        const btnDevice = makeBtn('Bu cihazdan çıkış yap', '#fff3f3', '#dc3545', '1px solid #f5c2c7', 'left');
        btnDevice.addEventListener('click', () => { close(); dispatch(LogoutDevice(navigate)); });

        const btnAll = makeBtn('Tüm cihazlardan çıkış yap', '#dc3545', '#fff', 'none', 'left');
        btnAll.addEventListener('click', () => { close(); dispatch(Logout(navigate)); });

        const btnCancel = makeBtn('İptal', '#f5f5f5', '#444', 'none', 'center');
        btnCancel.style.marginBottom = '0';
        btnCancel.addEventListener('click', close);

        box.appendChild(title);
        box.appendChild(subtitle);
        box.appendChild(btnDevice);
        box.appendChild(btnAll);
        box.appendChild(btnCancel);
        overlay.appendChild(box);

        overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });

        document.body.appendChild(overlay);
    }

    return (
        <button className="dropdown-item ai-icon" onClick={handleClick}>
            <svg
                id="icon-logout" xmlns="http://www.w3.org/2000/svg"
                className="text-danger" width={18} height={18} viewBox="0 0 24 24"
                fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"
            >
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1={21} y1={12} x2={9} y2={12} />
            </svg>
            <span className="ms-2">Çıkış Yap</span>
        </button>
    );
}

export default LogoutPage;
